import http from '@/utils/httpService';
import { rootPath } from '@/utils/globalParam';
// import fileExport from '@/utils/fileExport';
import fileExport from '@/utils/fileExportForGet';
// 保单合同分页查询
export const preservationList=data=>{
    return http.Axios.post(rootPath+'/api/preservation/preservationList',data)
}
//保全分页查询
export const preservationpolicyList=data=>http.Axios.post(rootPath+'/api/preservation/policyList',data)
// 保全按钮 (查询是否有上传文件 以及是否勾选保全项目)
export const preservationoperate=data=>http.Axios.post(rootPath+'/api/preservation/operate',data)
// 生成一条保全（点击加保减保等 先生成一条保全）
export const savePreservation=data=>http.Axios.post(rootPath+'/api/preservation/savePreservation',data)
// 保全操作明细(单条详情)
export const preservationgetDetail=data=>http.Axios.post(rootPath+'/api/preservation/getDetail',data)
// 保全历史(多条)
export const preservationgetHistory=data=>http.Axios.post(rootPath+'/api/preservation/getHistory',data)
// 批量导入
export const preservationupload=data=>http.Axios.post(rootPath+'/api/preservation/upload',data)
//下载导入模板
export const preservationdownload=(filename,data)=>fileExport(filename,data,'/api/preservation/download')
// 获取当前保单计划
export const preservationgetPlan=data=>http.Axios.post(rootPath+'/api/preservation/getPlan',data)
//保存被保人
export const preservationsaveInsured=data=>http.Axios.post(rootPath+'/api/preservation/saveInsured',data)
// 提交保全被保人到团财
export const preservationsubmitToGcbs=data=>http.Axios.post(rootPath+'/api/preservation/submitToGcbs',data)
// 查询当前保全所有被保人
export const preservationinsuredList=data=>http.Axios.post(rootPath+'/api/preservation/insuredList',data)
// 确认覆盖
export const preservationconfirmCover=data=>http.Axios.post(rootPath+'/api/preservation/confirmCover',data)
//删除所选被保人
export const preservationdelete=data=>http.Axios.post(rootPath+'/api/preservation/delete',data)
// 批量删除被保人
export const preservationbatchDelete=data=>http.Axios.post(rootPath+'/api/preservation/batchDelete',data)
// 提交保全被保人到幸福人寿
export const preservationsubmitToXfrs=data=>http.Axios.post(rootPath+'/api/preservation/submitToXfrs',data)
// 提交关联被保人
export const preservationsubmitRelative=data=>http.Axios.post(rootPath+'/api/preservation/submitRelative',data)

//撤销保全
export const preservationcancel=data=>http.Axios.post(rootPath+'/api/preservation/cancel',data)
// 查看异常数据
export const preservationunusualList=data=>http.Axios.post(rootPath+'/api/preservation/unusualList',data)
// 获取可编辑列表
export const preservationpreservation=data=>http.Axios.post(rootPath+'/api/preservation/getEditList',data)


// 返回修改
export const preservationedit=data=>http.Axios.post(rootPath+'/api/preservation/edit',data)

//删除保全
export const preservationdeletePreservation=data=>http.Axios.post(rootPath+'/api/preservation/deletePreservation',data)
// 减保的关闭关联被保人弹窗
export const preservationcloseRelative=data=>http.Axios.post(rootPath+'/api/preservation/closeRelative',data)
//查询手机号
export const preservationgetPhone=data=>http.Axios.post(rootPath+'/api/preservation/getPhone',data)

// 国家地区
export const getTbalNation=data=>http.Axios.post(rootPath+'/api/preservation/getTbalNation',data)
// 太保提交到保司 
export const submitToTbal=data=>http.Axios.post(rootPath+'/api/preservation/submitToTbal',data)
// 太保安联的保全历史
export const getTbalHistory=data=>http.Axios.post(rootPath+'/api/preservation/getTbalHistory',data)



